import { render, staticRenderFns } from "./LoanResponsibleChip.vue?vue&type=template&id=178ca1fa&"
import script from "./LoanResponsibleChip.vue?vue&type=script&lang=js&"
export * from "./LoanResponsibleChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports